// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38m72","label":"styles_label__2jwA0"};